<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-novo-motorista')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-motorista')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-position="top">
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('codigo')" prop="code">
              <el-input
                ref="code"
                :disabled="id !== ''"
                v-model="ruleForm.code"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5" :offset="1">
            <el-form-item
              :label="$t('ativo')"
              prop="active"
              class="is-required"
            >
              <el-switch v-model="ruleForm.active"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="15" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="$t('usuario')" prop="username">
              <el-input ref="username" v-model="ruleForm.username"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="id === ''" :xs="15" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="$t('senha')" prop="password">
              <el-input ref="password" v-model="ruleForm.password" readonly>
                <el-button
                  slot="append"
                  icon="el-icon-refresh"
                  @click="ruleForm.password = generatePassword()"
                  >Gerar outra</el-button
                >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item :label="$t('tipo')" prop="type">
              <el-select
                v-model="ruleForm.type"
                placeholder="Selecione  uma opção"
              >
                <el-option
                  key="deliver"
                  label="Entregador"
                  value="deliver"
                ></el-option>
                <el-option
                  key="driver"
                  label="Motorista"
                  value="driver"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item :label="$t('equipe')" prop="team">
              <TeamList
                v-model="ruleForm.team"
                v-bind:current="ruleForm.team"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-tabs v-model="activeTab">
          <el-tab-pane :label="$t('documentos')" name="document">
            <DriverDocuments ref="documents" />
          </el-tab-pane>
          <el-tab-pane :label="$t('endereco')" name="address">
            <el-row :gutter="5">
              <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="'CEP'" prop="zipcode">
                  <el-input
                    :maxlength="9"
                    v-model="ruleForm.zipcode"
                    v-mask="'#####-###'"
                    @blur="zipcode()"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item :label="$t('endereco')" prop="address">
                  <el-input v-model="ruleForm.address"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('bairro')" prop="neighborhood">
                  <el-input v-model="ruleForm.neighborhood"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('cidade')" prop="city">
                  <el-input v-model="ruleForm.city"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6" :lg="2" :xl="3">
                <el-form-item :label="$t('estado')" prop="state">
                  <el-input v-model="ruleForm.state"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('numero')" prop="number">
                  <el-input
                    type="number"
                    maxlength="6"
                    v-model="ruleForm.number"
                    v-mask="'######'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('complemento')" prop="extent">
                  <el-input
                    v-model="ruleForm.extent"
                    maxlength="255"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="Dados do contrato" name="contract">
            <el-row :gutter="5">
              <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
                <el-form-item prop="type">
                  <el-checkbox v-model="ruleForm.tac">Contrato TAC</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
                <el-form-item label="ANTT" prop="team">
                  <el-input v-model="ruleForm.antt"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
                <el-form-item label="Registro de autônomo" prop="team">
                  <el-input v-model="ruleForm.register"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="Veiculo" name="car">
            <el-row :gutter="5">
              <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8" class="right">
                <el-button type="primary" @click="dTruck = true"
                  >Adicionar novo veiculo</el-button
                >
              </el-col>
              <el-dialog
                title="Adicionar novo veiculo"
                :visible="dTruck"
                center
                :close-on-click-modal="false"
                :show-close="false"
              >
                <TruckAdd
                  ref="truckAdd"
                  @close="dTruck = false"
                  @save="truck"
                />
              </el-dialog>
            </el-row>
            <el-table :data="truckList" style="width: 100%">
              <el-table-column
                sortable
                :label="$t('placa')"
                prop="plate"
              ></el-table-column>
              <el-table-column
                sortable
                :label="$t('renavam')"
                prop="renavam"
              ></el-table-column>
              <el-table-column width="120px">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-delete"
                    @click="remove(scope.row.id)"
                    circle
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div class="bottom clearfix">
          <el-form-item>
            <el-button
              type="warning"
              v-if="id === ''"
              autofocus
              @click="submitForm('ruleForm')"
              >{{ $t("adicionar") }}</el-button
            >
            <el-button
              type="warning"
              v-if="id !== ''"
              autofocus
              @click="editForm('ruleForm')"
              >{{ $t("atualizar") }}</el-button
            >
            <el-button type="danger" @click="back()">{{
              $t("voltar")
            }}</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <PasswordCreatedDialog
      :visible="created.visible"
      :username="created.username"
      :password="created.password"
      @close="created.visible = false"
    />
  </div>
</template>
<script>
import { CouriesService } from "@/services/customers/couries.services";
import { i18n } from "@/plugin/i18n";
import TeamList from "@/xpost/views/umov/team/TeamList";
import TruckAdd from "./TruckAdd.vue";
import ZipMixins from "../../../mixins/zipcode";
import DriverDocuments from "./components/DriverDocuments.vue";
import PasswordCreatedDialog from "@/xpost/components/PasswordCreatedDialog.vue";
import { generatePassword } from "@/utils/password";

export default {
  name: "CouriesAdd",
  mixins: [ZipMixins],
  components: {
    TeamList,
    TruckAdd,
    DriverDocuments,
    PasswordCreatedDialog,
  },
  data() {
    return {
      dTruck: false,
      id: "",
      activeTab: "document",
      imageUrl: "",
      truckList: [],
      created: {
        visible: false,
        username: "",
        password: "",
      },
      ruleForm: {
        name: "",
        zipcode: "",
        address: "",
        neighborhood: "",
        city: "",
        state: "",
        number: "",
        extent: "",
        code: "",
        tac: true,
        regiter: "",
        antt: "",
        username: "",
        password: "",
        mail: "",
        type: "driver",
        imei: "",
        team: "",
        active: true,
      },
    };
  },

  methods: {
    generatePassword,
    back() {
      var vm = this;
      vm.$router.replace({
        name: "couriers",
      });
    },

    truck(truckData) {
      console.log(truckData);
      this.truckList.push(truckData);
      this.dTruck = false;
    },

    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      CouriesService.get(vm.id)
        .then((response) => {
          console.log(response);
          vm.ruleForm = response;
          vm.ruleForm.code = response.user.username;
          vm.ruleForm.name = response.user.name;
          vm.ruleForm.username = response.user.username;
          vm.ruleForm.active = response.user.active;
          vm.ruleForm.team = response.user.team ? response.user.team.id : "";
          vm.$refs.documents.set(response);
          vm.truckList = response.truck;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    submitForm(formName) {
      const vm = this;
      console.log("get", vm.$refs.documents, vm.$refs.documents.getForm);
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          CouriesService.add(
            vm.ruleForm,
            vm.$refs.documents.getForm,
            vm.truckList
          )
            .then(() => {
              this.$message({
                type: "success",
                message: i18n.tc("entregador-adicionado-sucesso"),
              });
              vm.created = {
                visible: true,
                username: vm.ruleForm.username,
                password: vm.ruleForm.password,
              };
              this.$refs[formName].resetFields();
              vm.ruleForm.password = generatePassword();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },

    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          vm.ruleForm.documents = vm.$refs.documents.ruleForm;
          CouriesService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("entregador-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.ruleForm.password = generatePassword();
      vm.$refs.code.$el.children[0].focus();
    }
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
